<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.fornecedores.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoFornecedores" }'
    )
    .detalhes-fornecedor
        h3.detalhes-fornecedor__titulo {{ $t('mensagens.fornecedores.labels.dadosCadastrais') }}
        .detalhes-fornecedor__card
            Resume(resumeId='detalhes-resumo-fornecedor', :resume='resumeList')
        h3.detalhes-fornecedor__titulo(v-if='cpfsCnpjs.length') {{ $t('mensagens.fornecedores.labels.dadosVinculados') }}
        .detalhes-fornecedor__card(v-if='cpfsCnpjs.length')
            ResumeList(
                resumeId='detalhes-cpf-cnpj-fornecedor',
                :label='$t("mensagens.fornecedores.keys.cpfsCnpjs")',
                :resume='cpfsCnpjs'
            )
        .footer
            .footer__btn.voltar(@click='irParaFornecedores')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
</template>
<script>
import formatters from '@/utils/formatters';

export default {
    name: 'DetalhesFornecedor',
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Resume: () =>
            import('@/components/contratosOriginacao/formulario/Resume'),
        ResumeList: () =>
            import('@/components/contratosOriginacao/formulario/ResumeList')
    },
    props: {
        resume: {
            type: [Array, Object],
            default: () => []
        }
    },
    data() {
        return {
            dados: {}
        };
    },
    computed: {
        resumeList() {
            const keysValids = ['nome', 'idSap'];
            const keys = Object.keys(this.dados);
            const keyMap = keys.map(key => ({
                key,
                label: this.$t(`mensagens.fornecedores.keys.${key}`),
                value: this.dados[key]
            }));
            const resume = keyMap.filter(
                item => keysValids.includes(item.key) && item.value
            );

            return resume;
        },
        cpfsCnpjs() {
            return this.resume.cpfsCnpjs.map(cpfCnpj => ({
                label: this.$t('mensagens.fornecedores.keys.cpfsCnpjs'),
                value: this.formataCpfCnpj(cpfCnpj)
            }));
        }
    },
    mounted() {
        this.montarDados();
    },
    methods: {
        montarDados() {
            const fornecedor = {
                nome: this.resume.nome,
                idSap: this.resume.idSap
            };

            this.dados = fornecedor;
        },
        irParaFornecedores() {
            this.$router.push({ name: 'ConfiguracaoFornecedores' });
        },
        formataCpfCnpj(value) {
            if (!value || value.trim() === '') return '-';
            return formatters.numeralStringFormatTocpfCnpj(value);
        }
    }
};
</script>

<style lang="scss">
.detalhes-fornecedor {
    margin: 20px;
    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }
    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();
        & + & {
            margin-top: 20px;
        }
    }
    &__lista {
        padding: 0 !important;
    }
    .footer {
        display: flex;
        justify-content: flex-end !important;
        margin-top: 20px;
    }

    .footer__btn {
        width: 100px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        border-radius: $default-border-radius;
        cursor: pointer;

        .mdi-arrow-left {
            color: var(--primary);
        }

        .mdi-arrow-right {
            color: $white;
        }
    }

    .footer__btn.voltar {
        background-color: transparent;
        color: var(--primary);
        border: 1px solid var(--primary);
    }

    .footer__btn.voltar:hover {
        background-color: var(--primary);
        color: $white;

        .mdi-arrow-left {
            color: $white;
        }
    }
}
</style>
